import { render, staticRenderFns } from "./Whitelabel.vue?vue&type=template&id=c1f37374&lang=pug&"
import script from "./Whitelabel.vue?vue&type=script&lang=js&"
export * from "./Whitelabel.vue?vue&type=script&lang=js&"
import style0 from "./Whitelabel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1f37374')) {
      api.createRecord('c1f37374', component.options)
    } else {
      api.reload('c1f37374', component.options)
    }
    module.hot.accept("./Whitelabel.vue?vue&type=template&id=c1f37374&lang=pug&", function () {
      api.rerender('c1f37374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/whitelabel/Whitelabel.vue"
export default component.exports